// extracted by mini-css-extract-plugin
export default {"chatBody":"App_chatBody__JcGHJ"};